/**
 * 持卡人端 URL 语言前缀：/{lang}/cardholder/... · /{lang}/login · /{lang}
 * lang ∈ zh | en；与 localStorage allinks_chd_lang 双写同步。
 */
import {
  CHD_FALLBACK_LANG,
  CHD_LANG_STORAGE_KEY,
  resolveChdLang,
  type ChdLang,
} from './resources';

export function isChdLang(raw: string | null | undefined): raw is ChdLang {
  return raw === 'zh' || raw === 'en';
}

/** 读取偏好语言：storage → 非法/缺失回落 en */
export function getPreferredLang(): ChdLang {
  if (typeof localStorage === 'undefined') {
    return CHD_FALLBACK_LANG;
  }
  return resolveChdLang(localStorage.getItem(CHD_LANG_STORAGE_KEY));
}

/**
 * 去掉路径开头的 /zh 或 /en 前缀。
 * /zh → / ； /en/cardholder/dashboard → /cardholder/dashboard
 */
export function stripLangPrefix(pathname: string): string {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const segments = normalized.split('/').filter(Boolean);
  if (segments.length === 0) {
    return '/';
  }
  if (isChdLang(segments[0])) {
    const rest = segments.slice(1);
    return rest.length === 0 ? '/' : `/${rest.join('/')}`;
  }
  return normalized === '' ? '/' : normalized;
}

/** 从路径解析语言前缀；无则 null */
export function parseLangFromPath(pathname: string): ChdLang | null {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length > 0 && isChdLang(segments[0])) {
    return segments[0];
  }
  return null;
}

/**
 * 生成带语言前缀的应用路径。
 * @param path 业务路径（可带或不带既有 lang 前缀），如 /cardholder/dashboard、login、/
 * @param lang 省略时用 getPreferredLang()
 */
export function localePath(path: string, lang?: ChdLang): string {
  const lng = lang ?? getPreferredLang();
  const bare = stripLangPrefix(path.startsWith('/') ? path : `/${path}`);
  if (bare === '/') {
    return `/${lng}`;
  }
  return `/${lng}${bare}`;
}

/** 将当前 pathname 换为另一语言，保留业务后缀 */
export function replaceLangInPath(pathname: string, next: ChdLang): string {
  return localePath(stripLangPrefix(pathname), next);
}
